export default "__VITE_ASSET__Df0O_iJ9__"